import { Icon } from './Icon';

/**
 * Аккаунт: сота с лицом.
 *
 * Единственный двухцветный значок в наборе, и это из макета: сота фиолетовая —
 * это оправа, лицо бирюзовое — это вы. Поэтому он не берёт currentColor, как
 * все остальные, а называет оба цвета сам.
 *
 * Коробка квадратная, как была: фигура 22×24 сдвинута на единицу вправо, иначе
 * значок сузился бы на два пиксела.
 */
export function AccountIcon({ size = 26 }: { size?: number }) {
  return (
    <Icon size={size} box={24} strokeWidth={1}>
      <path d="M12 1 L21 6 V18 L12 23 L3 18 V6 Z" stroke="var(--meza-violet)" />
      <circle cx="12" cy="10" r="2.6" stroke="var(--meza-cyan-bright)" />
      <path d="M7.6 17.6 q4.4 -3.8 8.8 0" stroke="var(--meza-cyan-bright)" />
    </Icon>
  );
}
